import * as React from 'react';
import { Form, Button, Affix, Input, Select, Tooltip, Popconfirm } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';
import * as reactLink from 'react-router-dom';
import { Container, Paper, Card, Breadcrumbs, Link, Typography } from '@mui/material';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { routeName } from '../routes/paths';

import DragSortingUpload from '../components/DragSortingUpload';
import NoSidebarLayout from './layout/nosidebar-layout';
import Editor from '../components/editor';
import axios from '../AxiosInstance';
import useNotification from '../components/notification';

export default function EditBlog() {
  const [bottomCard, setBottomCard] = React.useState({ backgroundColor: 'transparent', boxShadow: 'none' });
  const [form] = Form.useForm();
  const { id } = useParams();
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();
  const { sendNotification } = useNotification();

  const formItemLayout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 14,
    },
  };
  const { Option } = Select;
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }

    return e && e.fileList;
  };

  React.useEffect(() => {
    if (searchParams.get('type')) {
      let type = searchParams.get('type');
      form.setFieldsValue({
        blog_type_id: +type,
      });
    }
  }, [searchParams]);

  React.useEffect(() => {
    if (id !== 'add') {
      axios
        .get(`/blogs/${id}`)
        .then((res) => {
          const blogDetail = res.data;
          // console.log(blogDetail);
          form.setFieldsValue({
            featured_image: [{ url: blogDetail.featuredImage }],
            title: blogDetail.title,
            blog_type_id: blogDetail.blogTypeId,
            body: blogDetail.body,
            slug: blogDetail.slug,
          });
        })
        .catch((err) => {
          console.error(err);
          sendNotification({ msg: `Something Wrong`, variant: 'error' });
        });
    }
  }, []);

  const onAffixChange = (affixed) => {
    setBottomCard(!affixed ? { backgroundColor: 'transparent', boxShadow: 'none' } : null);
  };

  const cancelFormHandler = () => {
    navigate(-1);
  };

  const submitFormHandler = (values) => {
    const formData = new FormData();
    // console.log(values);
    // add new blog
    if (id === 'add') {
      formData.append('featuredImage', values.featured_image[0].originFileObj);
      formData.append('title', values.title);
      formData.append('body', JSON.stringify(values.body));
      formData.append('slug', values.slug);
      formData.append('blogTypeId', values.blog_type_id);

      axios
        .post('/blogs', formData)
        .then((res) => {
          // console.log(res.data);
          sendNotification({ msg: `Create new blogs success`, variant: 'success' });
          navigate(values.blog_type_id == 1 ? routeName.BLOGS : routeName.PROMOTIONS);
        })
        .catch((err) => {
          console.error(err);
          sendNotification({ msg: `Create Error`, variant: 'error' });
        });
    } else {
      // edit blog id

      if (!values.featured_image[0].url) formData.append('featuredImage', values.featured_image[0].originFileObj);
      // if (!values.heroImage[0].url) formData.append('heroImage', values.heroImage[0].originFileObj);
      // formData.append('featuredImage', values.featured_image[0].originFileObj);
      formData.append('title', values.title);
      formData.append('body', JSON.stringify(values.body));
      formData.append('slug', values.slug);
      formData.append('blogTypeId', values.blog_type_id);

      axios
        .put(`/blogs/${id}`, formData)
        .then((res) => {
          // console.log(res.data);
          sendNotification({ msg: `Update blog success`, variant: 'success' });
          navigate(values.blog_type_id == 1 ? routeName.BLOGS : routeName.PROMOTIONS);
        })
        .catch((err) => {
          console.error(err);
          sendNotification({ msg: `Update Error`, variant: 'error' });
        });
    }
  };

  return (
    <NoSidebarLayout>
      <Container maxWidth='lg'>
        <Breadcrumbs separator='>'>
          <Link component={reactLink.Link} to={routeName.BLOGS}>
            Main
          </Link>

          <Typography>{id === 'add' ? 'Add New Blog' : 'Edit Blog'}</Typography>
        </Breadcrumbs>

        <Form name='edit_blog' form={form} {...formItemLayout} onFinish={submitFormHandler}>
          <Card sx={{ my: 2 }}>
            <Container sx={{ py: 3 }}>
              <h2>{id === 'add' ? 'Add New blog' : 'Edit blog'}</h2>

              <Form.Item
                label='Cover Image'
                name='featured_image'
                valuePropName='fileList'
                required
                rules={[{ required: true, message: 'กรุณาเพิ่มรูปหน้าปก' }]}
                getValueFromEvent={normFile}>
                <DragSortingUpload maxCount={1} />
              </Form.Item>

              <Form.Item name='title' label='หลักข้อ' required rules={[{ required: true, message: 'กรุณาระบุหัวข้อ' }]}>
                <Input placeholder='หัวข้อ' />
              </Form.Item>

              <Form.Item
                name='blog_type_id'
                label='หมวดหมู่'
                // hasFeedback
                required
                rules={[{ required: true, message: 'กรุณาระบุหมวดหมู้' }]}
                style={{ width: '100%' }}
                // rules={[{ required: true, message: 'Please select your country!' }]}>
              >
                <Select placeholder='เลือกหมวดหมู่'>
                  <Option value={1}>บทความ</Option>
                  <Option value={2}>โปรโมชั่น</Option>
                </Select>
              </Form.Item>

              <Form.Item name='slug' label='Slug' required rules={[{ required: true, message: 'กรุณาระบุ slug URL' }]}>
                <Input
                  placeholder='slug url ควรใช้เป็นภาษาอังกฤษ'
                  suffix={
                    <Tooltip title='slug url ควรใช้เป็นภาษาอังกฤษและไม่มีเว้นวรรค เช่น this-is-an-example'>
                      <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                    </Tooltip>
                  }
                />
              </Form.Item>

              <Form.Item name='body' label='รายละเอียด' getValueFromEvent={(value) => value}>
                <Editor placeholder={'รายละเอียดบทความหรือโปรโมชั่น'} />
              </Form.Item>
            </Container>
          </Card>
          <Affix offsetBottom={0} onChange={onAffixChange}>
            <Paper sx={{ my: 2, pt: 3, pb: 1, ...bottomCard }} elevation={5}>
              <Form.Item
                wrapperCol={{
                  span: 5,
                  offset: 16,
                }}>
                <Popconfirm
                  title='ละทิ้งการแก้ไขทั้งหมด?'
                  onConfirm={cancelFormHandler}
                  // onCancel={cancel}
                  okText='ตกลง'
                  cancelText='ยกเลิก'>
                  <Button style={{ marginInline: 10 }}>Cancel</Button>
                </Popconfirm>
                <Button style={{ marginInline: 10 }} type='primary' htmlType='submit'>
                  Submit
                </Button>
              </Form.Item>
            </Paper>
          </Affix>
        </Form>
      </Container>
    </NoSidebarLayout>
  );
}
